

const actions = {
  FETCH_PUBLISHING_DRAFT: 'publishing/FETCH_PUBLISHING_DRAFT',
  FETCH_APPROVAL_NEEDED: 'publishing/FETCH_APPROVAL_NEEDED',
  FETCH_HISTORY: 'publishing/FETCH_HISTORY',
}

export default actions
